import ICookie from '../models/ICookie';

export default class CookieService {

  private static instance: CookieService;
  public static SESSION_NAME = 'IUCN_USER_SESSION'
  public static SESSION_USER_GROUP = 'IUCN_USER_GROUP'
  public static SESSION_ADMIN_GROUP = 'IUCN_ADMIN_GROUP'
  public static SESSION_VIEW_GROUP = 'IUCN_VIEW_GROUP'
  public static SESSION_AGREED_PRIVACY = 'IUCN_AGREED_PRIVACY'
  public static SESSION_OPEN_AGREED_PRIVACY_OPENED = 'IUCN_OPEN_AGREED_PRIVACY'

  /**
   * Init service instance
   */
   public static initInstance(): void {
    if (!CookieService.instance) {
      CookieService.instance = new CookieService();
    }
  }

  /**
   * Get service instance
   */
   public static getInstance(): CookieService {
    return CookieService.instance;
  }

  /**
   * Get session cookie
   * @returns 
   */
  public getCookie(): ICookie | null {

    try {
      const decodedCookie = decodeURIComponent(window.localStorage.getItem(CookieService.SESSION_NAME) || '');

      if (decodedCookie) {
        const cookieObj = JSON.parse(decodedCookie);
        const sessionObj = JSON.parse(cookieObj.session);
        const cookie = {...cookieObj, ...{token: sessionObj.token}} as ICookie;
        return cookie;
      }

      return null;
    }
    
    catch(err: any) {
      return null;
    }
  }

  /**
   * Set cookie
   * @param cookie 
   */
   public setCookie(cookie: ICookie) { 
    window.localStorage.setItem(CookieService.SESSION_NAME, JSON.stringify(cookie));
    //window.localStorage.setItem(CookieService.SESSION_USER_GROUP, JSON.stringify(cookie));
  }
  
  /**
   * Destroy cookie
   */
   public destroyCookie() {    
    window.localStorage.setItem(CookieService.SESSION_NAME, '');
    window.localStorage.setItem(CookieService.SESSION_USER_GROUP, '');
    window.localStorage.setItem(CookieService.SESSION_ADMIN_GROUP, '');
    window.localStorage.setItem(CookieService.SESSION_VIEW_GROUP, '');
    window.localStorage.setItem(CookieService.SESSION_AGREED_PRIVACY, '');
    window.localStorage.setItem(CookieService.SESSION_OPEN_AGREED_PRIVACY_OPENED, '');
  }

  /**
   * Get session esri token
   * @returns 
   */
   public getSessionEsriToken(): string {

    try {
      const decodedCookie = decodeURIComponent(document.cookie);
      const arr = decodedCookie.split(';');
      const cookieStr: string | undefined = arr.find(str => str.trim().indexOf(CookieService.SESSION_NAME) === 0);

      if (cookieStr) {
        const cookieObj = JSON.parse(cookieStr.trim().replace(`${CookieService.SESSION_NAME}=`, ''));

        if (cookieObj.session) {
          const sessionObj = JSON.parse(cookieObj.session);

          if (sessionObj.token) {
            return sessionObj.token;
          }
        }
      }

      return '';
    }
    
    catch(err: any) {
      return '';
    }
  }
}
